function usePreserveRecipient() {
  const extractRecipient = (searchString: string): string => {
    const searchParams = new URLSearchParams(searchString);
    const recipient = searchParams.get('recipient');

    return recipient ? `?recipient=${recipient}` : '';
  };

  const createUrlWithRecipient = (
    basePath: string,
    searchString: string,
  ): string => {
    const recipientParam = extractRecipient(searchString);
    return `${basePath}${recipientParam}`;
  };

  return {
    extractRecipient,
    createUrlWithRecipient,
  };
}

export { usePreserveRecipient };
